// utils/formatNumber.js
export const formatNumberWithSpaces = (number) => {
  if (number === null || number === undefined) return '';
  
  // Convert to string and remove any existing formatting
  const numStr = String(number).replace(/\s/g, '');
  
  // Add space as thousands separator
  return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

// Alternative using Intl.NumberFormat (more robust for different locales)
export const formatNumberWithSpacesIntl = (number, locale = 'fr-FR') => {
  if (number === null || number === undefined) return '';
  
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    useGrouping: true
  }).format(number).replace(/,/g, ' '); // Replace commas with spaces
};